// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gu2F","input":"styles_input__1jJGQ"};